import { render, staticRenderFns } from "./MenuLinks.vue?vue&type=template&id=dd9a3b1c&"
import script from "./MenuLinks.vue?vue&type=script&lang=js&"
export * from "./MenuLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports